export class MenuDetail {
    code: string;
    label: string;
    action?: () => void

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.code        = data['code'] ? data['code'] : null;
        this.label       = data['label'] ? data['label'] : null;
        this.action       = data['action'] ? data['action'] : undefined;
    }
}
